//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: [],
    data: function data() {
        return {
            url: route('sanctum_api.mailtemplates.index'),
            columns: [{
                name: 'lang',
                label: trans('columns.lang'),
                sortable: true
            },
            /*{
                name: 'slug',
                label: trans('columns.slug'),
                sortable: true
            },*/
            {
                name: 'subject',
                label: trans('columns.subject'),
                sortable: true
            }]
        };
    },

    methods: {
        canEdit: function canEdit() {
            return window.Laravel.permissions.includes('mailtemplates.edit');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Mailtemplates.vue
// module id = 42
// module chunks = 0